import { createModalStore } from '@/shared/lib/modal';

export const useUploadSrtModalStore = createModalStore();
